<template>
    <button type="button">
        Press Me!
    </button>
</template>

<script setup lang="ts">

</script>

<style lang="scss" scoped></style>